export function AppLoadingScreen() {
  return (
    <main className="app-loading" role="status" aria-live="polite" aria-label="Preparando RoguelikeFC">
      <section className="app-loading__panel">
        <svg className="app-loading__crest" data-testid="loading-crest" viewBox="0 0 64 72" aria-hidden="true">
          <path fill="#83a9da" stroke="#0d191d" strokeLinejoin="round" strokeWidth="3" d="M32 2 58 12v24c0 15-10.8 27.2-26 34C16.8 63.2 6 51 6 36V12L32 2Z" />
          <path fill="none" stroke="#f1ead8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M32 51V35m0 16L18.5 42m13.5 9 13.5-9" />
          <circle cx="32" cy="25" r="12" fill="#0d191d" /><circle cx="32" cy="25" r="8.5" fill="#f1ead8" />
          <path fill="#0d191d" d="m32 19.2 5.4 3.9-2.1 6.3h-6.6l-2.1-6.3 5.4-3.9Z" />
          <path fill="none" stroke="#0d191d" strokeLinecap="round" strokeWidth="2" d="m26.7 23.5-3-1.1m5.4 6.5-1.8 2.5m7.6-2.5 1.8 2.5m.6-7.9 3-1.1M32 19v-2.6" />
          <circle cx="18.5" cy="42" r="5.2" fill="#0d191d" /><circle cx="18.5" cy="42" r="2.5" fill="#f1ead8" />
          <circle cx="45.5" cy="42" r="5.2" fill="#0d191d" /><circle cx="45.5" cy="42" r="2.5" fill="#e3b84d" />
          <circle cx="32" cy="51" r="5.2" fill="#0d191d" /><circle cx="32" cy="51" r="2.5" fill="#f1ead8" />
        </svg>
        <p className="eyebrow">RoguelikeFC</p>
        <h1>Preparando tu carrera…</h1>
        <span className="app-loading__track" aria-hidden="true"><span /></span>
      </section>
    </main>
  )
}
